import React from "react";
var __jsx = React.createElement;
import { useTranslation } from 'react-i18next';
import IconNoOrder from "../../../../assets/images/no-order.svg";
import { StyledEmptyOrder } from "./styled";

var EmptyOrder = () => {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return __jsx(StyledEmptyOrder, null, __jsx("img", {
    src: IconNoOrder
  }), __jsx("div", {
    className: "note"
  }, t('no_orders')));
};

export default EmptyOrder;